<template>
    <div>
        <template v-if="contentAreas?.length">
            <PageContentMobileContentArea
                v-for="(contentArea, index) in contentAreas" :key="contentArea" :page-id="pageId"
                :content-area="contentArea" :content-area-first="index === 0"
                :content-area-last="index === contentAreas.length - 1"
                :content-areas="contentAreas"/>

            <PageContentOrphaned :page-id="pageId" :content-areas="contentAreas" class="mb-3"/>
        </template>
        <PageContentSections v-else-if="pageSections?.length" :page-id="pageId"/>
    </div>
</template>

<script>
import PageContentMobileContentArea from './PageContentMobileContentArea'
import PageContentOrphaned from "./PageContentOrphaned.vue"
import PageContentSections from "./PageContentSections.vue"

export default {
    name: "PageContentMobile",
    components: {
        PageContentSections,
        PageContentOrphaned,
        PageContentMobileContentArea
    },
    props: {
        pageId: Number
    },
    computed: {
        pageSections() {
            return this.$store.state.pageSections.items.filter(o => o.pageId === this.pageId)
        }
    },
    asyncComputed: {
        contentAreas() {
            return this.$store.dispatch('pageTemplatesContentAreas/getPagesContentAreas', this.pageId)
        }
    },
    created() {
        this.$store.dispatch('pageSections/init')
    }
}
</script>

<style scoped>

</style>